/**
 *   Created by ATopcu in 2019
 */
import { exchange } from "@ls/js-fetch";
import SummaryType from "state/selections/Constants/SummaryType";
import SelectionState from "state/selections/SelectionState";
import { selectGetBaseGroupingParams } from "state/selections/selector";
import scope from "./scope";
import { selectDefinitions } from "./selectors";
export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});

export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});

export const REQUEST_DATA = `${scope}/REQUEST_DATA`;
export const RECEIVE_DATA = `${scope}/RECEIVE_DATA`;
export const REQUEST_SBS_DATA = `${scope}/REQUEST_SBS_DATA`;
export const RECEIVE_SBS_DATA = `${scope}/RECEIVE_SBS_DATA`;
export const requestRatingsData = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const definitions = selectDefinitions(SelectionState.COMMITTED)(state);
    const getBaseGroupingParams = selectGetBaseGroupingParams(state);

    if (definitions?.length) {
      const analytics = new Set(),
        ratingModes = new Set(),
        ratingMetrics = new Set();
      let benchesToo = false;
      definitions.forEach((def) => {
        analytics.add(def.analytic);
        ratingModes.add(def.ratingMode.value);
        ratingMetrics.add(def.ratingMetric.value);
        if (def.summary === SummaryType.BENCHMARK) {
          benchesToo = true;
        }
      });
      dispatch({ type: REQUEST_DATA, summary: SummaryType.ABSOLUTE });
      const [params, sbsParams] = getBaseGroupingParams({
        summary: SummaryType.ABSOLUTE,
        benchesToo: benchesToo,
        analytics: Array.from(analytics),
        quality_rating_modes: Array.from(ratingModes),
        quality_rating_metrics: Array.from(ratingMetrics),
      });
      const url = process.env.REACT_APP_BASE_URL_GROUPING_SERVICE;

      dispatch({
        type: RECEIVE_DATA,
        summary: SummaryType.ABSOLUTE,
        data: (
          await exchange({
            url,
            params,
            cancelId: `data-${scope}`,
          })
        )?.data,
      });

      if (sbsParams) {
        dispatch({ type: REQUEST_SBS_DATA, summary: SummaryType.ABSOLUTE });
        dispatch({
          type: RECEIVE_SBS_DATA,
          summary: SummaryType.ABSOLUTE,
          data: (
            await exchange({
              url,
              params: sbsParams,
              cancelId: `data-sbs-${scope}`,
            })
          )?.data,
        });
      }
    }
  };
};
